<app-resp-popup-title>
  <span>Aufgaben importieren</span>
</app-resp-popup-title>
<app-resp-popup-content class="content">
  <div class="wrapper">
    <div class="row">
      <div class="col">
        <frm-file-select label="CSV-Datei auswählen..." [allowMultipleFiles]="false"
        (fileSelectionChanged)="OnUpload($event[0])" fileRestrictions=".csv"></frm-file-select>
      </div>
      <div class="col-auto" style="align-content: center;">
        <ctrl-btn (click)="OnOpenCsvSpecification()"
          i18n-title='Hilfe CSV-Datei|Hilfe zur Formatierung der CSV-Datei@@helpformatingCSVfile'
        title="Help to formate a CSV-file" content="Format" icon="help"></ctrl-btn>
      </div>
    </div>
    <div style="height: 65vh;">
      <app-list-view [dataSource]="dataSource" [columns]="columns" [elevated]="false" [compact]="true"
        [getRowStyle]="RowCallback" [canRowExpand]="ItemHasErrors" expansionMode="multi">
        <ng-template cstListViewDetailTemplate let-item="item">
          <section>
            <div style="margin: 0px 0px 10px 0px;">
              <div class="card">
                <div class="card-body">
                  {{ item.errorDescription }}
                </div>
              </div>
            </div>
          </section>
        </ng-template>
      </app-list-view>
    </div>
  </div>
  @if (importIsLoading) {
    <mat-progress-spinner mode="determinate" [value]="progress"></mat-progress-spinner>
  }
</app-resp-popup-content>

<app-resp-popup-actions>
  <ctrl-btn [loading]="importIsLoading" [disabled]="!importGridData" [icon]="hasAnyErrors ? 'warning' : 'done'"
    [type]="hasAnyErrors ? 'warn' : 'primavry'"
    [content]="hasAnyErrors ? 'Fehler ignorieren und Aufgaben trotzdem importieren' : 'Importieren'"
  (click)="OnStartImport()"></ctrl-btn>
  <ctrl-btn-cancel (click)="close()"></ctrl-btn-cancel>
</app-resp-popup-actions>